import React, { useState } from 'react';
import { useStore } from '../../../store/useStore';

import Loader from '../common/Loader';

import Timestamp from '../common/Timestamp';
import CustomTable from '../common/CustomTable';
import { HeaderAmount } from './HeaderAmount';
import UserName from '../common/UserName';

export default function MessageList({ dashboardView, tableConfig, preFilter }) {
	const { state } = useStore();
	const [filter, setFilter] = useState();

	const { messages: dataSource } = state;
	const { items } = dataSource;

	const preCustomFilter = preFilter
		? preFilter
		: () => {
				return true;
		  };

	const processedRows = items
		.map((item) => {
			const newItem = { ...item };
			return newItem;
		})
		.filter(preCustomFilter)
		.reverse();

	const data = React.useMemo(() => {
		if (processedRows) {
			if (dashboardView) {
				return processedRows.sort((a, b) => {
					return new Date(b.updated_at) - new Date(a.updated_at);
				});
			} else {
				return processedRows;
			}
		} else {
			return [];
		}
	}, [dashboardView, processedRows]);

	const columns = React.useMemo(
		() => [
			{
				Header: 'ID',
				accessor: 'id',
			},
			{
				Header: 'type',
				accessor: 'type',
			},
			{
				Header: 'template',
				accessor: 'template',
			},
			{
				Header: 'to',
				accessor: 'to',
				Cell: ({ value }) => {
					if (typeof value === 'string') {
						return <span>{value}</span>;
					} else {
						return <span>{(value && typeof value.join == 'function') && value.join(', ')}</span>;
					}
				},
			},
			{
				Header: 'Viesti',
				accessor: 'message',
				Cell: ({ value, row }) => {
					return <p className="message-value">{value}</p>;
				},
			},
			{
				Header: 'user_id',
				accessor: 'user_id',
				Cell: ({ value }) => {
					return <UserName user_id={value} useLink={true} />;
				},
			},
			{
				Header: 'Aika',
				accessor: 'created_at',
				Cell: ({ value }) => {
					return (
						<Timestamp
							timestamp={value}
							pure={true}
							format={'dd.MM.yyyy HH:mm:ss'}
						/>
					);
				},
			},
		],
		[]
	);

	if (dataSource.loading === true || !dataSource.items) {
		return <Loader className="dark" />;
	}

	return (
		<section className="common-list messagelist">
			<div className="common-list-header">
				<h1>Lähetyslogi</h1>
				<MessageHeader data={processedRows} />
			</div>
			{!dashboardView && (
				<>
					<input
						placeholder="Etsi"
						name="etsi"
						type="text"
						value={filter || ''}
						onChange={(e) => setFilter(e.target.value)}
					/>
				</>
			)}
			{filter && filter !== '' && <h3>{`Tuloksia hakusanalla '${filter}'`}</h3>}
			<CustomTable
				data={data}
				columns={columns}
				filter={filter}
				hidePagination={dashboardView}
				config={tableConfig}
			/>
		</section>
	);
}

export const MessageHeader = (props) => {
	const data = props.data ? props.data : [];
	// const isPublished = data.filter((i) => i.is_published === 1);
	// const isSent = data.filter((i) => i.is_sent === 1);

	return (
		<>
			<div className="common-list-data">
				<HeaderAmount label="Yhteensä" value={data.length} />
				{/* <HeaderAmount label="Julkaistu" value={isPublished.length} /> */}
			</div>
		</>
	);
};
